import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showLoading: false, // 显示加载遮罩
    topic: '', //当前主题
    subTopic: '',
    appInstance: false, // 地图初始化成功
    sceneName: '中国', // 当前场景名称 '中国', '北京', '园区',
    sceneSeason: '', // 地图季节 空代表不开启季节
    sceneTime: '时间', // 地图时间
    sceneWeather: '晴天', // 地图天气
    cameraInfo: '', //摄像机视角
    cameraRotate: false, //相机旋转
    spaceLevel: '', // '中国', '北京', '园区', '楼层', '房间', '机柜', '设备'
    spaceName: '', // 空间名称
    functionStatus: '默认状态', // '默认状态', '路径漫游', '数据分析', '对象分析', '告警事件'
    highLight: '', // 当前高亮的卡片
    selectCity: '深圳市', // 下拉菜单选择的城市
    selectLegends: [], //散点,
    scatterTypeSSGJ: 'VIP人员',
    prevModelLayer: {
      id: '0'
    },
    rightComponents: "",
    objectInfo: {}, // 左侧点击的对象数据详情
    LandmarkLayerIdObj: '', //点击散点存放的ID
    modelId: "",
    LegendTextInfo: '',
    tipTxt: '漫游提示内容', // 漫游提示内容
    isOpenDoor: false,
    DoorStatus: {
      1002: false,
      1003: false,
    }
  },
  mutations: {
    setDoorStatus(state, info) {
      state.DoorStatus = { ...state.DoorStatus, ...info }
    },
    setIsOpenDoor(state, flag) {
      state.isOpenDoor = flag
    },
    setLoading(state, flag) {
      state.showLoading = flag
    },
    // 切换主题
    setTopic(state, name) {
      state.topic = name
    },
    // 设置二级专题
    setSubTopic(state, name) {
      state.subTopic = name
    },
    // 地图是否初始化
    setAppInstance(state, flag) {
      state.appInstance = flag
    },
    // 设置高亮卡片
    setHighLight(state, name) {
      state.highLight = name
    },
    setSceneName(state, info) {
      state.sceneName = info
    },
    setCameraInfo(state, info) {
      state.cameraInfo = info
    },
    setSceneTime(state, info) {
      state.sceneTime = info
    },
    setSceneWeather(state, info) {
      state.sceneWeather = info
    },
    setCameraRotate(state, flag) {
      state.cameraRotate = flag
    },
    // 设置下拉菜单选择的城?
    changeSelectCity(state, val) {
      state.selectCity = val
    },
    //设置新的图例图层
    setSelectLegend(state, list) {
      state.selectLegends = list
    },
    //移除某个图例
    removeSelectLegend(state, name) {
      state.selectLegends.remove(name)
    },
    //清空图例图层
    clearSelectLegend(state) {
      state.selectLegends = []
    },
    //追加图例名称
    pushSelectLegend(state, name) {
      state.selectLegends.push(name)
    },
    setFunctionStatus(state, name) {
      state.functionStatus = name
    },
    setSpaceLevel(state, list) {
      if (typeof list == 'string') {
        state.spaceLevel = list
        state.spaceName = ''
      } else {
        state.spaceLevel = list[0]
        state.spaceName = list[1]
      }
    },
    setCameraLevel(state, name) {
      state.cameraLevel = name
    },
    setModelTip(state, name) {
      state.prevModelLayer = name
    },
    setscatterTypeSSGJ(sate, info) {
      sate.scatterTypeSSGJ = info
    },
    setRightComponents(state, name) {
      state.rightComponents = name
    },
    setObjectInfo(state, info) {
      state.objectInfo = info
    },
    setLandmarkLayerIdObj(sate, info) {
      sate.LandmarkLayerIdObj = info
    },
    setModelId(state, id) {
      state.modelId = id
    },
    setLegendTextInfo(state, info) {
      state.LegendTextInfo = info
    },
    setTipTxt(state, info) {
      state.tipTxt = info
    }
  },
  actions: {},
  modules: {}
})